import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
import AdvancedSearchContext from "../../../application/Context/AdvancedSearchContext";
import ProjectsContext from "../../../application/Context/ProjectsContext";
import MarketsContext from "../../../application/Context/MarketsContext";
import NewsSearchContext from "../../../application/Context/NewsSearchContext";
import MembersContext from "../../../application/Context/MembersContext";
import DocLibContext from "../../../application/Context/DocLibContext";
import EventsSearchContext from "../../../application/Context/EventsSearchContext";
import BonsCoupsContext from "../../../application/Context/BonsCoupsContext";
import { motion } from "framer-motion";
import { MultiSelectionWrapper } from "../shared-components/SideFilter/MultiSelectionWrapper/MultiSelectionWrapper";
import { Filters as ProjectsMarketsFilters } from "../projects-components/Filters";
import { Filters as NewsFilters } from "../search-news-components/Filters";
import { Filters as MembersFilters } from "../members-components/Filters";
import { Filters as DocLibFilters } from "../doc-lib-components/Filters";
import { Filters as EventsFilters } from "../events-components/Filters";
import { Filters as BonsCoupsFilters } from "../bonscoups-components/Filters";
export var AllFilters = function () {
    var t = useTranslation(["titles"]).t;
    var _a = React.useContext(AdvancedSearchContext), displayedFilter = _a.displayedFilter, setRandQuery = _a.setRandQuery;
    var _b = React.useContext(ProjectsContext), ProjectsFromCtx = _b.rows, ProjectsSetAdvSearch = _b.setAdvSearch, ProjectsSetRandQuery = _b.setRandQuery;
    var _c = React.useContext(MarketsContext), MarketsFromCtx = _c.rows, MarketsSetAdvSearch = _c.setAdvSearch, MarketsSetRandQuery = _c.setRandQuery;
    var _d = React.useContext(MembersContext), MembersFromCtx = _d.rows, MembersSetAdvSearch = _d.setAdvSearch, MembersSetRandQuery = _d.setRandQuery;
    var _e = React.useContext(NewsSearchContext), NewsFromCtx = _e.rows, NewsSetAdvSearch = _e.setAdvSearch, NewsSetRandQuery = _e.setRandQuery;
    var _f = React.useContext(DocLibContext), DocsFromCtx = _f.rows, DocsSetAdvSearch = _f.setAdvSearch, DocsSetRandQuery = _f.setRandQuery;
    var _g = React.useContext(EventsSearchContext), EventsFromCtx = _g.rows, EventsSetAdvSearch = _g.setAdvSearch, EventsSetRandQuery = _g.setRandQuery;
    var _h = React.useContext(BonsCoupsContext), BonsCoupsFromCtx = _h.rows, BonsCoupsSetAdvSearch = _h.setAdvSearch, BonsCoupsSetRandQuery = _h.setRandQuery;
    React.useEffect(function () {
        ProjectsSetAdvSearch(true);
        MarketsSetAdvSearch(true);
        MembersSetAdvSearch(true);
        NewsSetAdvSearch(true);
        DocsSetAdvSearch(true);
        EventsSetAdvSearch(true);
        BonsCoupsSetAdvSearch(true);
        setRandQuery(Math.random().toString());
    }, [
        ProjectsFromCtx,
        MarketsFromCtx,
        MembersFromCtx,
        NewsFromCtx,
        DocsFromCtx,
        EventsFromCtx,
        BonsCoupsFromCtx
    ]);
    React.useEffect(function () {
        ProjectsSetAdvSearch(true);
        MarketsSetAdvSearch(true);
        MembersSetAdvSearch(true);
        NewsSetAdvSearch(true);
        DocsSetAdvSearch(true);
        EventsSetAdvSearch(true);
        ProjectsSetRandQuery(Math.random());
        MarketsSetRandQuery(Math.random());
        MembersSetRandQuery(Math.random());
        NewsSetRandQuery(Math.random());
        DocsSetRandQuery(Math.random());
        EventsSetRandQuery(Math.random());
        BonsCoupsSetRandQuery(Math.random());
        return function () {
            ProjectsSetAdvSearch(false);
            MarketsSetAdvSearch(false);
            MembersSetAdvSearch(false);
            NewsSetAdvSearch(false);
            DocsSetAdvSearch(false);
            EventsSetAdvSearch(false);
            BonsCoupsSetAdvSearch(false);
        };
    }, []);
    return (_jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: displayedFilter == "Tous" && (_jsxs(_Fragment, { children: [_jsx(MultiSelectionWrapper, { title: t("Avis"), children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: _jsx(ProjectsMarketsFilters, {}) }) }), _jsx(MultiSelectionWrapper, { title: t("Marchés"), children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: _jsx(ProjectsMarketsFilters, { application: "markets" }) }) }), _jsx(MultiSelectionWrapper, { title: t("Membres"), children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.2 }, exit: { opacity: 0 }, children: _jsx(MembersFilters, {}) }) }), _jsx(MultiSelectionWrapper, { title: t("Nouvelles"), children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.2 }, exit: { opacity: 0 }, children: _jsx(NewsFilters, {}) }) }), _jsx(MultiSelectionWrapper, { title: t("Documents"), children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.2 }, exit: { opacity: 0 }, children: _jsx(DocLibFilters, {}) }) }), _jsx(MultiSelectionWrapper, { title: t("Events"), children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: _jsx(EventsFilters, {}) }) }), _jsx(MultiSelectionWrapper, { title: t("Bons Coups"), children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: _jsx(BonsCoupsFilters, {}) }) })] })) }));
};
